<template>
  <svg
    viewBox="0 0 1738 1738"
    xmlns="http://www.w3.org/2000/svg"
    class="svg-icon"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
  >
    <g>
      <path
        d="M868.748,0c479.479,0 868.752,389.274 868.752,868.748c-0,479.479 -389.273,868.752 -868.752,868.752c-479.474,-0 -868.748,-389.273 -868.748,-868.752c0,-479.474 389.274,-868.748 868.748,-868.748Zm-0,92.654c428.34,-0 776.098,347.755 776.098,776.094c0,428.34 -347.758,776.098 -776.098,776.098c-428.339,0 -776.094,-347.758 -776.094,-776.098c-0,-428.339 347.755,-776.094 776.094,-776.094Z"
      />
    </g>
    <path
      d="M762.592,868.054l-222.888,222.888c-13.841,13.846 -21.621,32.621 -21.621,52.2c0,19.579 7.779,38.354 21.621,52.2c0.354,0.354 0.709,0.708 1.067,1.062c13.841,13.846 32.621,21.625 52.196,21.625c19.579,0 38.358,-7.779 52.2,-21.625l222.887,-222.883l222.888,222.883c13.846,13.846 32.62,21.625 52.2,21.625c19.579,0 38.354,-7.779 52.2,-21.625c0.354,-0.354 0.708,-0.708 1.062,-1.062c13.846,-13.846 21.625,-32.621 21.625,-52.2c0,-19.579 -7.779,-38.354 -21.625,-52.2l-222.883,-222.888l222.883,-222.887c13.846,-13.842 21.625,-32.621 21.625,-52.2c0,-19.575 -7.779,-38.354 -21.625,-52.196c-0.354,-0.358 -0.708,-0.713 -1.062,-1.067c-13.846,-13.841 -32.621,-21.621 -52.2,-21.621c-19.58,0 -38.355,7.78 -52.2,21.621l-222.888,222.888l-222.887,-222.888c-13.842,-13.841 -32.621,-21.621 -52.2,-21.621c-19.575,0 -38.354,7.78 -52.196,21.621c-0.358,0.354 -0.713,0.709 -1.067,1.067c-13.841,13.842 -21.621,32.621 -21.621,52.196c0,19.579 7.78,38.358 21.621,52.2l222.888,222.887Z"
    />
  </svg>
</template>

<script>
export default {
  name: "IconCircleReject"
};
</script>
